import { formatarMoeda } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";

const TIPO_SOLICITACAO_LABELS = {
    LIMITE: "Limite",
    PRAZO: "Prazo",
    AMBOS: "Ambos",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheLimitePrazo({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Informações Gerais</h2>
                <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-sm">
                    <Campo label="Filial" valor={detalheProcesso.filialNome} />
                    <Campo label="Tipo da Solicitação" valor={TIPO_SOLICITACAO_LABELS[detalheProcesso.tipoSolicitacao] || detalheProcesso.tipoSolicitacao} />
                    <Campo label="Código da Rota" valor={detalheProcesso.codigoRota} />
                    <Campo label="Supervisor" valor={detalheProcesso.supervisor} />
                    <Campo label="Aprovação Parcial" valor={detalheProcesso.aprovacaoParcial != null ? (detalheProcesso.aprovacaoParcial ? "Sim" : "Não") : null} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Cliente</h3>
                <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-sm">
                    <Campo label="Código" valor={detalheProcesso.clienteCodigo} />
                    <div className="col-span-2">
                        <Campo label="Razão Social" valor={detalheProcesso.clienteRazaoSocial} />
                    </div>
                    <div className="col-span-3">
                        <Campo label="Nome Fantasia" valor={detalheProcesso.clienteFantasia} />
                    </div>
                    <Campo label="Bairro" valor={detalheProcesso.clienteBairro} />
                    <Campo label="Cidade" valor={detalheProcesso.clienteCidade} />
                    <Campo label="Estado" valor={detalheProcesso.clienteEstado} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Limite</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Limite Atual" valor={detalheProcesso.limiteAtual != null ? formatarMoeda(detalheProcesso.limiteAtual) : null} />
                    <Campo label="Limite Proposto" valor={detalheProcesso.limiteProposto != null ? formatarMoeda(detalheProcesso.limiteProposto) : null} />
                    <Campo label="Limite Aprovado" valor={detalheProcesso.limiteAprovado != null ? formatarMoeda(detalheProcesso.limiteAprovado) : null} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Prazo</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Prazo Atual" valor={detalheProcesso.prazoAtual != null ? `${detalheProcesso.prazoAtual} dias` : null} />
                    <Campo label="Prazo Proposto" valor={detalheProcesso.prazoProposto != null ? `${detalheProcesso.prazoProposto} dias` : null} />
                    <Campo label="Prazo Aprovado" valor={detalheProcesso.prazoAprovado != null ? `${detalheProcesso.prazoAprovado} dias` : null} />
                </div>
            </div>

            {detalheProcesso.motivoAlteracao && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Motivo da Alteração</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.motivoAlteracao}</p>
                </div>
            )}

            {detalheProcesso.justificativaSupervisor && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (Supervisor)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaSupervisor}</p>
                </div>
            )}

            {detalheProcesso.justificativaFinanceiro && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (Financeiro)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaFinanceiro}</p>
                </div>
            )}
        </div>
    );
}